// ============================================
// 外部ファイル
// ============================================
import logoRotateAnimation from '../animation/logoRotateAnimation';

(() => {
	// ============================================
	// 実行
	// ============================================
	// 外部ファイル
	logoRotateAnimation(
		'data-rotate_icon',
		false
	);
})();